import {useCallback, useRef} from "react";
import {isAxiosError, isCancel} from "axios";
import {notifyError} from "./ErrorNotification.ts";

/** Reports one failure per outage and allows another notification after recovery. */
export function useBackgroundErrorNotification() {
    const reported = useRef(false);
    const report = useCallback((error: unknown, message: string) => {
        if (isCancel(error) || (isAxiosError(error) && error.response?.status === 401)) return;
        if (reported.current) return;
        reported.current = true;
        notifyError(error, message);
    }, []);
    const recover = useCallback(() => {
        reported.current = false;
    }, []);
    return {report, recover};
}
